/**
 * Selector de densidad de la retícula de colección.
 *
 * La preferencia se guarda en localStorage porque cruza páginas: quien navega
 * el catálogo en una columna espera seguir en una columna al pasar de página o
 * al entrar en otra colección.
 *
 * Progresivo por diseño: sin JS el grid ya renderiza en la densidad por defecto
 * que pone Liquid en el atributo data-density.
 */

const STORAGE_KEY = 'sc:collection-density';
const ALLOWED = ['1', '2', '4'];

class ScCollectionGrid extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('[ref="grid"]');
    this.buttons = [...this.querySelectorAll('[data-density]')].filter(
      (el) => el.tagName === 'BUTTON'
    );

    if (!this.grid) return;

    this.applyDensity(this.storedDensity ?? this.dataset.defaultDensity ?? '2', {
      persist: false,
    });

    this.buttons.forEach((btn) => {
      btn.addEventListener('click', () => this.applyDensity(btn.dataset.density));
    });
  }

  get storedDensity() {
    try {
      const value = localStorage.getItem(STORAGE_KEY);
      return ALLOWED.includes(value) ? value : null;
    } catch {
      return null; // Safari en privado lanza al leer localStorage.
    }
  }

  applyDensity(density, { persist = true } = {}) {
    if (!ALLOWED.includes(density)) return;

    this.grid.dataset.density = density;

    this.buttons.forEach((btn) => {
      btn.setAttribute('aria-pressed', String(btn.dataset.density === density));
    });

    if (!persist) return;

    try {
      localStorage.setItem(STORAGE_KEY, density);
    } catch {
      // Sin persistencia el cambio sigue aplicando en esta página.
    }
  }
}

if (!customElements.get('sc-collection-grid')) {
  customElements.define('sc-collection-grid', ScCollectionGrid);
}
